import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function BannerContent() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('400wrigidsolarpanel');
    const { locale } = useRouter();

    return (
        <>
            <section className={`${css.componentRoot} BannerContent`}>
                <div className="top-box">
                    <article className="rate-box">
                        <div className="rate-conversion">{t('solarpanels_400w_rigid.conversion_rate')}</div>
                        <div className="box-bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_1.webp')}
                                src={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_1.png')}
                                className="fullImgs"
                                alt={t('solarpanels_400w_rigid.conversion_rate')}
                            />
                        </div>
                    </article>
                    <div className="other-top">
                        <div className="ip68-box">
                            {!['fr'].includes(locale) && (
                                <>
                                    <span className="ip68-text">{t('solarpanels_400w_rigid.second_ip')}</span>
                                    <span className="ip68-desc">{t('solarpanels_400w_rigid.second_waterproof')}</span>
                                </>
                            )}
                            {['fr'].includes(locale) && (
                                <>
                                    <span className="ip68-desc">{t('solarpanels_400w_rigid.second_waterproof')}</span>
                                    <span className="ip68-text">{t('solarpanels_400w_rigid.second_ip')}</span>
                                </>
                            )}
                            <div className="box-bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_2.webp')}
                                    src={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_2.png')}
                                    className="fullImgs"
                                    alt={t('solarpanels_400w_rigid.second_ip')}
                                />
                            </div>
                        </div>
                        <div className="compatible-box">
                            <span className="compatible">{t('solarpanels_400w_rigid.second_easy_to_plug')}</span>
                            <div className="box-bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_3.webp')}
                                    src={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_3.png')}
                                    className="fullImgs"
                                    alt={t('solarpanels_400w_rigid.second_easy_to_plug')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <article className="other-box">
                    <div className="other-bottom">
                        <span className="other-text-left">{t('solarpanels_400w_rigid.off_grid_solution')}</span>
                        <span className="other-text-right">{t('solarpanels_400w_rigid.on_grid_solution')}</span>
                        <div className="box-bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_4.webp')}
                                src={require('@publicLocal/product/solarpanel_400w_rigid/h5/02_4.png')}
                                className="fullImgs"
                                alt={t('solarpanels_400w_rigid.on_grid_solution')}
                            />
                        </div>
                    </div>
                </article>
            </section>
        </>
    );
}
